import { useContext, useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import ApprovalDialogBox from './ApprovalDialogBox';
import { Edit, History } from '@mui/icons-material';
import MyContext from '../../Context/AppContext';
import EditUser from '../../assets/images/editUser.svg'

const ApprovedUsers = ({ rows, setRows, isDataLoading, setIsDataLoading }) => {
  const { setUsageModal } = useContext(MyContext);
  const [openEditConfigDialog, setOpenEditConfigDialog] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [targetRow, setTargetRow] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (e,row) => {
    setAnchorEl(e.currentTarget);
    setTargetRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  }

  const handlePaginationModelChange = (newModel) => {
    setPaginationModel(newModel);
  };

  const handleEditConfiguration = () => {
    setSelectedUserData(targetRow)
    setOpenEditConfigDialog(true);
    handleClose();
  };

  const handleUsageChecking = () => {
    setUsageModal({
      isOpen: true,
      userId: targetRow._id,
    });
    handleClose();

  }

  const handleApprovedUserRowChange = (targetRow, payload) => {
    const kendoData = [...rows];
    const index = kendoData.findIndex((item) => item._id === targetRow._id);
    kendoData[index].accountConfig.accountType = payload?.accountType;
    kendoData[index].accountTypeInfo = payload?.accountType;
    kendoData[index].accountConfig.jdLimit = payload?.jdLimit;
    kendoData[index].jdLimit = payload?.jdLimit;
    kendoData[index].accountTypeName = payload?.accountType?.typename;
    kendoData[index].accountConfig.contractEndDate = payload?.expiryDate;
    kendoData[index].accountExpiryDate = payload?.expiryDate;
    kendoData[index].accountConfig.permissions = payload?.permissions;
    kendoData[index].accountConfig.roleAccessId = payload?.roleAccessId;
    setRows(kendoData);
    setIsDataLoading(false);
  }


  const allColumns = [
    {
      field: 'actions',
      headerName: 'Action',
      width: 100,
      headerAlign: 'center',
      filterable: false,
      disableColumnMenu: true,
      sortable: false,
      pinned: true,
      renderCell: (params) => (
        <div className='buttonContainer_signupRequest'>
          <Button
            variant='contained'
            size="small"
            className='button_editConfig_approveUser'
            color="primary"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={(e) => handleClick(e,params.row)}
          >
            Action
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem onClick={() => handleEditConfiguration()} className='menuItem_approvedUserTable' >
              <img src={EditUser} alt="Edit" className='editUserIcon' />
              <span>Edit configuration</span>
            </MenuItem>
            <MenuItem onClick={()=> handleUsageChecking()} className='menuItem_approvedUserTable' >
              <History />
              <span>Usage history</span>
            </MenuItem>
          </Menu>
        </div>
      )
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 150,
      filterable: true,
      pinned: true,
      cellClassName: 'compact-cell'
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 200,
      filterable: true,
      pinned: true,
      cellClassName: 'compact-cell'
    },
    { field: 'orgName', headerName: 'Organization', width: 180 },
    { field: 'role', headerName: 'Role', width: 150 },
    { field: 'countryName', headerName: 'Country', width: 150 },
    { field: 'contactNo', headerName: 'Contact Number', width: 150 },
    { field: 'accountTypeName', headerName: 'Account Type', width: 150 },
    { field: 'approvedByName', headerName: 'Approved By', width: 150 },
    {
      field: 'approvalDate',
      headerName: 'Approval Date',
      width: 140,
      valueFormatter: params => moment(params.value).format('DD-MMM-YYYY')
    },
    {
      field: 'accountExpiryDate',
      headerName: 'Account Expiry Date',
      width: 180,
      valueFormatter: params => moment(params.value).format('DD-MMM-YYYY')
    }
  ];

  return (
    <>
      <div className="grid-container">
        <DataGrid
          rows={rows}
          columns={allColumns}
          getRowId={(row) => row._id}
          className='dataGrid_pendingInvites'
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          pageSizeOptions={[10]}
          loading={isDataLoading}
          pagination
          disableRowSelectionOnClick
          hideFooterSelectedRowCount
          disableColumnMenu
          disableColumnReorder
          columnBuffer={2}
          rowBuffer={10}
          rowHeight={52}
          headerHeight={40}
          disableVirtualization={false}
          pinnedColumns={{
            left: ['actions', 'name', 'email']
          }}
          initialState={{
            pinnedColumns: {
              left: ['actions', 'name', 'email']
            }
          }}
        />
      </div>
      <ApprovalDialogBox
        open={openEditConfigDialog}
        handleClose={() => setOpenEditConfigDialog(false)}
        isEdit={true}
        userData={selectedUserData}
        setKendoDataLoading={setIsDataLoading}
        handleApprovedUserRowChange={handleApprovedUserRowChange}
      />
    </>
  );
}

export default ApprovedUsers;
